export enum HealthDataType {
	DEFAULT = 'default',
	RAW = 'raw',
}
